const AVAILABLE_DTYPES = {
  'object': 'text',
  'datetime64[ns]': 'date',
  'int64': 'int',
  'float64': 'float',
  'float to text without decimal': 'float to text without decimal',
};

export const getSearchParam = (key=null) => {
  const params = new window.URLSearchParams(window.location.search);
  if (!key) return params;
  return params.get(key) || null
};

/**
 * https://stackoverflow.com/a/48764436
 * 
 * Round half away from zero ('commercial' rounding)
 * Uses correction to offset floating-point inaccuracies.
 * Works symmetrically for positive and negative numbers.
 */
function round(num, decimalPlaces = 0) {
  const p = Math.pow(10, decimalPlaces);
  const n = (num * p) * (1 + Number.EPSILON);
  return Math.round(n) / p;
}

export const getNumericalValue = (value, decimalPlaces, emptyValue = "-", locale = "fr") => {
  if (value === "0.0 %" || value === "NaN%") {
    return "0 %";
  }
  if (!value) return emptyValue;
  if (typeof value === typeof 1) {
    if (value === 0) {
      return emptyValue;
    }

    value = decimalPlaces ? round(value, decimalPlaces) : round(value);
    if (locale !== null) {
      value = value.toLocaleString(locale).replace(/\s/g, "\xa0").replace(",", ".");
    } else {
      value = value.toString()
    }
    if (value.search("[1-9]") < 0) {
      return emptyValue;
    }
  }
  if (value === "0") {
    return emptyValue;
  }
  return value;
};

export const translatePandasTypesToHuman = (pandasType) => {
  if (!pandasType) return '';
  if (pandasType.toLowerCase().includes('mm')) return 'Date';
  return AVAILABLE_DTYPES[pandasType.toLowerCase()] || AVAILABLE_DTYPES[pandasType] || pandasType;
};

const dateFormats = [
  'YYYYMMDD',
  'YYYYDDMM',
  'DDMMYYYY',
  'MMDDYYYY',
  'YYYY/MM/DD',
  'YYYY-MM-DD',
  'YYYY/DD/MM',
  'YYYY-DD-MM',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'MM-DD-YYYY',
  'MM/DD/YYYY',
  'MMDD',
];

export const GROUPED_TYPES = {
  'Numeric': {
    'int64': 'Int',
    'float64': 'Float'
  },
  'Text': {
    'object': 'Text',
    'float to text without decimal': 'Float to text without decimal'
  },
  'Date': dateFormats,
};
